import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import GlobalMeta from "../../reusable/GlobalMeta";
import InternalBanner from "../../reusable/fieldGroups/InternalBanner";
import PageMenu from "../../menus/PageMenu";
import GridMenu from "../../menus/GridMenu";
import PageContent from "../../layout/PageContent";
import ImageBGSection from "../../reusable/fieldGroups/ImageBGSection";
import { Box } from "@mui/system";

export default function About(){
     
    const [pageData, setPageData]=useState();

    //Fetch page
    const { isPending, isError, data, error }=useQuery(
        ['about'], //Query key
        ()=>axios({ //Query function
            method:'get',
            url:WP_API_Settings.endpoint+'wp/v2/pages?slug=about&_embed=true&acf_format=standard'
        })
    );

    useEffect(()=>{
        if(data?.data){
            setPageData(data.data[0]);
        }
    },[data]);

    //console.log(pageData)

    return(
        <>
            <GlobalMeta/>
            <InternalBanner
                featuredImage={pageData?. _embedded?.['wp:featuredmedia']?.[0]?.source_url}
                banner={pageData?.acf.internal_banner}
                isAboutPage
            />
            <PageMenu
                items={pageData?.acf.page_menu}
                loading={!pageData}
            />
            <PageContent
                content={pageData?.content.rendered}
            />
            <GridMenu
                items={pageData?.acf.page_menu}
                loading={!pageData}
                acf={pageData?.acf}

                />
                <ImageBGSection
                    content={pageData?.acf.image_background} 
                    loading={!pageData} 
                />
                <Box sx={{height: '32px'}}></Box>
        </>
    )
}